import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';
import { Reveal } from '@/components/Reveal';

export default function CtaBand() {
  const { content, route, waLink } = useLang();
  const c = content.ctaBand;
  return (
    <section className="py-20 lg:py-24">
      <div className="container-x">
        <Reveal>
          <div data-testid="cta-band" className="grain relative overflow-hidden rounded-[2.5rem] bg-brand-deep px-8 py-14 text-center lg:px-16 lg:py-20">
            <div className="grid-dots absolute inset-0 opacity-30" />
            <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-brand-blue/30 blur-3xl" />
            <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-brand-cyan/20 blur-3xl" />
            <div className="relative">
              <h2 className="mx-auto max-w-2xl font-display text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">{c.title}</h2>
              <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">{c.subtitle}</p>
              <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  to={route('contact')}
                  data-testid="ctaband-quote-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-brand-blue px-7 py-3.5 text-sm font-semibold text-white shadow-[0_16px_36px_-14px_rgba(30,159,224,0.9)] transition hover:bg-brand-bluedark"
                >
                  {c.button}
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="ctaband-whatsapp-btn"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-semibold text-white transition hover:border-brand-cyan hover:text-brand-cyan"
                >
                  <MessageCircle className="h-4 w-4" />
                  {content.hero.ctaWa}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}